import { Typography } from 'antd';
import { CardContent, MetricCardEcho } from './common';
import { formatCurrency } from '@/utils/currencyUtils';
import type { NetworkEarnings } from '@/types';
import { useEarningsQuery } from '@/services/revenueApi';
import useFetchQuery from '@/hooks/useFetchQuery';

const TotalEstimatedEarningsCardEcho = ({ className }: { className?: string }) => {
  const { queryResult: earnings } = useFetchQuery(useEarningsQuery);
  const { data: earningsData } = earnings;

  return (
    <MetricCardEcho
      className={className}
      testId="total-estimated-earnings-card"
      title="Total estimated earnings"
      body={
        <CardContent
          {...earnings}
          data={earningsData}
          variant="echo"
          renderData={(data: NetworkEarnings) => <Data data={data} />}
        />
      }
    />
  );
};

const Data = ({ data }: { data: NetworkEarnings }) => (
  <Typography.Title level={3} ellipsis={{ rows: 1 }} style={{ margin: 0 }}>
    {formatCurrency(
      data.total_network_estimated_earnings?.amount ?? 0,
      data.total_network_estimated_earnings?.currency
    )}
  </Typography.Title>
);

export default TotalEstimatedEarningsCardEcho;
